import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'
import axios from 'axios'
import localStorageKey from '@/constants/localStorageKey'
import { getItemByLocalStorage } from '@/utils/localStorage'
import { API_CATALOG, API_VERSION, API_REPORT_URL } from '@/.env'

export default class CatalogService extends BaseService {
  static get entity () {
    return 'catalogs'
  }

  static async getCategoryByOutlet (storeId, outletId, page) {
    try {
      const response = await axios.get(`${API_CATALOG}/${API_VERSION}/stores/${storeId}/catalogs`, { params: { outletIds: outletId, page: page, limit: 50 } })
      if (response.data) {
        const data = { ...response.data, outletId: outletId }
        return new ResponseWrapper(response, data)
      }
    } catch (error) {
      throw new ErrorWrapper(error, error.message)
    }
  }

  static async getCategoriesFilter (query) {
    try {
      const response = await axios.get(`${API_REPORT_URL}/${API_VERSION}/stores/${getItemByLocalStorage(localStorageKey.STORE_ID)}/categories/filter`, {
        params: {
          ...query,
          outletIds: query.outletIds ? (query.outletIds || []).join(',') : query.outletIds,
          registerIds: query.registerIds ? (query.registerIds || []).join(',') : query.registerIds
        }
      })
      if (response.data) {
        const data = { ...response.data }
        return new ResponseWrapper(response, data)
      }
    } catch (error) {
      throw new ErrorWrapper(error, error.message)
    }
  }
}
